<template>
  <div>
    <portal  target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :noSearchFilter="true"
        :selectedCategory="seletedCategory"
        :noLanguageFilter="true"
        />
    </portal>
    <Row :gutter="15" type="flex" class="column-5 mb-30">
      <Col>
         <div @click="routeToUploadPage" class="card-gradient bg-gradient-green pointer is-hover">
          <h3 class="d-flex justify-content-between">
            <span class="text-lg text-gradient-dark-mdm-green">
              {{$t('MDM_UPLOAD')}}
            </span>
            <svgicon name="mdm-upload" width="16" height="16" :original="true" />
            <!-- Future Implementation -->
            <!-- <div class="d-flex align-item-center ml-auto">
              <div class="d-flex align-item-center ml-auto">
                <span class="box-radius is-text text-orange-dark">
                  4 Items
                </span>
              </div>
            </div> -->
          </h3>
          <div class="card-body" v-if="hasApproverAuthorization && noOfApprovalsPending >= 0">
            <div class="list-bullet">
              <i class="dot-gradient"></i>
              {{ getApprovalsPending }}
            </div>
          </div>
        </div>
      </Col>
      <div class="ml-auto">
        <div class="row p-10">
        <SwitchBtn
          v-model="openInNewTab"
          label="right"
          size="small"
          active-text="OPEN IN NEW TAB"
          inactive-text="OPEN IN NEW TAB"
          @change="setSession($event, 'openNewTab')"
          class="default-switch">
        </SwitchBtn>
      </div>
      <div class="row p-10">
        <SwitchBtn
          v-model="showCounts"
          label="right"
          size="small"
          active-text="SHOW COUNT"
          inactive-text="SHOW COUNT"
          @change="setSession($event, 'showCount')"
          class="default-switch">
        </SwitchBtn>
        </div>
      </div>
    </Row>
    <Row :gutter="15" type="flex" class="column-5 mb-30" v-for="(mdmObj,index) in menuOptionData" :key="index">
        <MdmCol
         v-for="(mdm,index) in mdmObj"
        :mdmObj="mdm"
        :key="index"
        :openInNewTab="Boolean(openInNewTab)"
        :showCounts="Boolean(showCounts)"
        />
    </Row>
  </div>
</template>

<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdm from '@/components/mixins/SharedMdmV2';
import MdmCol from './MdmCol';

export default {
  components: {
    MdmCol,
    PrimaryFilter,
  },
  mixins: [SharedMdm],
  data() {
    return {
      openInNewTab: true,
      showCounts: false,
      menuOptionData: [],
      noOfApprovalsPending: -1,
      hasApproverAuthorization: false,
    };
  },
  computed: {
    getApprovalsPending() {
      const defaultMessage = this.$t('MDM_COUNT_DEFAULT_MESSAGE');
      if (this.noOfApprovalsPending >= 0) {
        if (this.noOfApprovalsPending === 1) {
          return `${this.noOfApprovalsPending} ${this.$t('MDM_STATUS_APPROVAL_PENDING')}`;
        }
        return this.noOfApprovalsPending ? `${this.noOfApprovalsPending} ${this.$t('MDM_STATUS_APPROVALS_PENDING')}`
          : defaultMessage;
      }
      return '';
    },
  },
  methods: {
    routeToUploadPage() {
      localStorage.setItem('mdm-upload-section', '');
      if (this.openInNewTab) {
        const route = this.$router.resolve({ name: 'Upload' });
        window.open(route.href, '_blank');
      } else {
        return this.$router.push({ name: 'Upload' });
      }
    },
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
    setSession(event, type) {
      localStorage.setItem(type, event);
    },
  },
  async created() {
    const getTabSession = localStorage.getItem('openNewTab');
    const getShowCount = localStorage.getItem('showCount');
    this.showCounts = getShowCount || false;
    this.openInNewTab = getTabSession || true;
    this.menuOptionData = [];
    this.menuOptionData = JSON.parse(JSON.stringify(this.menuOptions));
    this.menuOptionData.shift(); // removes data manager from the menuoptions
    this.menuOptionData = this.sliceIntoChunks(this.menuOptionData, 5);
    this.hasApproverAuthorization = this.$hasPermission('mdm_approval') &&
      this.$hasPermission('mdm_approval_accept_reject') &&
      this.$hasFeature('bulk_upload_approval_flow'); //  approval flow authorization
    //  Backend call to get the number of approval pending items
    if (this.hasApproverAuthorization) {
      const result = await this.$store.dispatch('mdmV2/getNoOfApprovalsPending');
      if (result && (result.data || result.data === 0)) {
        this.noOfApprovalsPending = result.data;
      }
    }
  },
};
</script>
